import endpoint from './UrlEndpoints'
import StorageService from "./StorageService";
import {ApiResponseError, ApiService} from './ApiService';

const HTTP_ERROR_EXPIRED_TOKEN = 401;

export default class AuthService {

    static async isAuthenticated() {
        const token = await StorageService.getAccessToken();
        if (token !== null && token.length > 0) {
            //Test an authorized URL. If it fails meaning it was a stale session token
            try{
                await ApiService.get(endpoint.SESSION_VALIDITY_CHECK);
            }catch(err){
                if(err instanceof ApiResponseError && (err.response.status = HTTP_ERROR_EXPIRED_TOKEN)){
                    console.log("Session expired. Relogin");
                    return false;
                }
            }

            return true;
        } else {
            return false;
        }
    }

    static async logout() {
        await StorageService.removeAccessToken();
    }

    static async login(email, password) {
        /*
        const request = {
            "username": email,
            "password": password,
            "grant_type": "password",
            "client_id": "Dashboard"
        };
        */
       const request="username=" + email + "&password=" + password + "&grant_type=password";
        try {
            const resp = await ApiService.postOAuth(endpoint.LOGIN, request);
            await StorageService.setAccessToken("Bearer " + resp.data.access_token);
            await StorageService.setEmail(email)
        } catch (error) {
            throw error
        }
    }

    static async checkAuthorisation() {
        return await ApiService.get(endpoint.AUTHORISATION);
    }
}